// Ordinais devem casar 1:1 com o enum do backend (EF grava como int). Indefinido=5 estava
// faltando aqui; Desconto=6 e Adicional=7 (#20765/#20767).
export enum TipoSignificadoRubricaProvedorConciliacaoFatura {
  Mensalidade,
  Coparticipacao,
  TaxaImplantacao,
  InclusaoRetroativa,
  ExclusaoRetroativa,
  Indefinido,
  Desconto,
  Adicional,
}
